import { getAuthHeaders } from '@/identity.js';

/**
 * Tells identity the caller has seen the Microsoft Graph search notice, so `GET /v1/me` stops
 * sending `graphSearchNoticeRequired: true`. No body; identity answers 204.
 */
export async function acknowledgeGraphSearchNotice(): Promise<void> {
  const response = await fetch('/v1/me/graph-search-notice', {
    method: 'POST',
    headers: await getAuthHeaders(),
    credentials: 'same-origin',
  });
  if (!response.ok) {
    throw new Error(
      `POST /v1/me/graph-search-notice returned ${response.status}`,
    );
  }
}
